// Section Shopify Shopify.theme editor events

$(document)
.on('shopify:section:reorder', function(e){

  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if (Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.unload();
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

});

$(document)
.on('shopify:section:load', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  var sectionObjectUrl = $section.find('[data-theme-editor-load-script]').attr('src');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];

      // Check to see if section script exists
      if (typeof Shopify.theme[triggerClass] == 'undefined') {
        // make AJAX call to load script
        Shopify.theme.loadScript(triggerClass, sectionObjectUrl, function () {
          Shopify.theme[triggerClass].init($(section));
        });
      } else {
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(section));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          var $block = $('.'+ triggerClass)
          var blockUrl = $block.find('[data-theme-editor-load-script]').attr('src');

          // Check to see if section script exists
          if (typeof Shopify.theme[triggerClass] == 'undefined') {
            // make AJAX call to load script
            Shopify.theme.loadScript(triggerClass, blockUrl, function () {
              Shopify.theme[triggerClass].init($block);
            });
          } else {
            if (Shopify.theme[triggerClass]) {
              // console.log('Block: ' + triggerClass + ' has been loaded.')
              Shopify.theme[triggerClass].init($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
            }
          }

        }
      }
    });
  }

  // Load video feature
  // Shopify.theme.video.init();

  // Scrolling animations
  Shopify.theme.animation.init();

  // Initialize reviews
  Shopify.theme.productReviews.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  // Infinite scrolling
  Shopify.theme.infiniteScroll.init();

});


$(document)
.on('shopify:section:unload', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass]) {
        // console.log('Section: ' + triggerClass + ' is unloaded.')
        Shopify.theme[triggerClass].unload($(section));
      } else {
        // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          if (Shopify.theme[triggerClass]) {
            // console.log('Block: ' + triggerClass + ' is unloaded.')
            Shopify.theme[triggerClass].unload($(this));
          } else {
            // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
          }

        }
      }
    });
  }

  // Scrolling animations
  Shopify.theme.animation.unload($section);

  // QuantityBox
  Shopify.theme.quantityBox.unload($section);

  //Infinite scrolling
  Shopify.theme.infiniteScroll.unload($section);

});

$(document)
.on('shopify:section:select', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force show state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
      }
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  if ($('.newsletter-form__wrapper .contact-form').length > 0) {
    Shopify.theme.newsletterAjaxForm.init();
  }

  if(isScreenSizeLarge() && Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

  if ($('.block__recommended-products').length > 0) {
    var $productPage = $('.block__recommended-products').parents('.product-page');
    Shopify.theme.jsRecommendedProducts.init($productPage);
  }

});

$(document)
.on('shopify:section:deselect', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force hide state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
      }
    }
  }

});

// Block Shopify Shopify.theme editor events

$(document)
.on('shopify:block:select', function(e){

  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  var $block = $('#shopify-section-' + blockId);

  if($('.jsFeaturedPromos').length > 0) {
    Shopify.theme.jsFeaturedPromos.blockSelect($parentSection, blockId);
  }

  if($('.jsSlideshowWithText').length > 0) {
    Shopify.theme.jsSlideshowWithText.blockSelect($parentSection, blockId);
  }

  if ($('.jsSlideshowClassic').length > 0) {
    Shopify.theme.jsSlideshowClassic.blockSelect($parentSection, blockId);
  }

  if($('.jsTestimonials').length > 0) {
    Shopify.theme.jsTestimonials.blockSelect($parentSection, blockId);
  }

  // Sidebar collection multi-tag filter
  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();
});

$(document)
.on('shopify:block:deselect', function(e){

  var $block = $('#shopify-section-' + e.detail.blockId);

  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.closeSidebarBlock($toggleBtn);
    }
  }

});

$(document)
.on('shopify:block:load', function(e){



});

// Document ready
$(function() {

  var $jsSections = $('.shopify-section[class*=js]');

  // Loop through sections with js classes and load them in
  var $jsSectionNames = $jsSections.each(function () {
    for (var i = 0; i < this.classList.length; i++) {
      if (this.classList[i].substring(0, 2) === "js"){
        var triggerClass = this.classList[i];
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(this));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }

      }
    }
  });

  //hide blank product tabs
  var $productTabs = $('.product-description-tab');

  $productTabs.each(function () {
    if ($(this).text().trim() == '') {
      $(this).hide();
    }
  });

  var resizeTimer;

  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      Shopify.theme.objectFitImages.calculateAspectRatio();
      Shopify.theme.jsProduct && Shopify.theme.jsProduct.disableSlideshow(null, $('.product-gallery__main:not([data-quickshop-gallery]), .product-gallery__thumbnails:not(.js-gallery-carousel)'));
      Shopify.theme.jsProduct && Shopify.theme.jsProduct.enableSlideshow($('.product-gallery__main:not([data-quickshop-gallery])'));

      if (!isScreenSizeLarge()){

        // When 798 or less
        Shopify.theme.jsHeader.unload();
        Shopify.theme.mobileMenu.init();

      } else {

        // When larger than 798
        Shopify.theme.jsHeader.unload();
        Shopify.theme.mobileMenu.unload();
        Shopify.theme.jsHeader.init($('.jsHeader'));

        // Swatches
        if(Shopify.theme_settings.product_form_style == 'swatches') {
          Shopify.theme.thumbnail.enableSwatches();
        }

        Shopify.theme.jsProduct.enableStickyScroll($('.product-template--image-scroll').find('.sticky-product-scroll'));
      }

    }, 250);

  });

  //Enable plyr
  // Shopify.theme.video.init();

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  // QuantityBox
  Shopify.theme.quantityBox.init();

  /* Show secondary image on hover */
  if (Shopify.theme_settings.show_secondary_image == true) {
    Shopify.theme.thumbnail.showVariantImage();
  }

  // Collection swatches
  if (Shopify.theme_settings.show_collection_swatches) {
    Shopify.theme.thumbnail.enableSwatches();
  }

  // Quick shop
  if (Shopify.theme_settings.enable_quickshop) {
    Shopify.theme.thumbnail.showQuickShop();
  }

  // Currency converter
  if (Currency.show_multiple_currencies) {
    Shopify.theme.currencyConverter.init();
  }

  //Infinite scrolling
  if ($('[data-custom-pagination]').length) {
    Shopify.theme.infiniteScroll.init();
  }

  //Select event for native multi currency checkout
  $('.shopify-currency-form select').on('change', function () {
    $(this)
      .parents('form')
      .submit();
  });

  // Tabs
  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  // Additional checkout buttons
  if (!isScreenSizeLarge()) {
    $('.additional-checkout-buttons').addClass('additional-checkout-buttons--vertical');
  }

  // Accordion
  if($('.accordion, [data-cc-accordion]').length > 0) {
    Shopify.contentCreator.accordion.init();
  }

  // Backwards compatiblity for Flexslider
  if($('.slider, .flexslider').length > 0) {
    Shopify.contentCreator.slideshow.init();
  }

  // Newsletter AJAX Form
  if ($('.newsletter-form__wrapper .contact-form').length > 0) {
    Shopify.theme.newsletterAjaxForm.init();
  }

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  // Flickity IOS Fix
  Shopify.theme.flickityIosFix();


});

/*============================================================================
Slideshow arrows
==============================================================================*/


if(Shopify.theme_settings.icon_style == 'icon_solid') {
  var arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';
} else {
  var arrowShape = 'M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z';
}

// HOMEPAGE

// $('.homepage-brand-gallery-wrapper').flickity({
//   prevNextButtons: false,
//   watchCSS: true,
//   pageDots: false,
//   cellAlign: 'left',
//   wrapAround: true,
//   autoPlay: true
// });

//CONTACT US PAGE - scroll page to success message position after form submission

setTimeout(function () {
  if ($('body').hasClass('page-contact') && $('.success-message').length) {
    var offset = 210;
    $('html,body').animate({scrollTop: $('.success-message').offset().top - offset},'slow');
  }
}, 500);

// HEADER

$('.mobile-dropdown').find('.region-selector').click(function() {
  if($(this).hasClass('active')) {
    $(this).removeClass('active');
  }
  else {
    $(this).addClass('active');
  }
});
$(document).click(function(e) {
  const $target = $(e.target);
    if(!$target.closest('.mobile-dropdown .region-selector').length) {
      $('.mobile-dropdown').find('.region-selector').removeClass('active');
    }
});

$('.header-search').find('.header__link').click(function(e) {
  if($('.header-search').hasClass('active')) {
    const $searchText = $('.header-search').find('input').val();
    if(!$searchText.length) {
      $('.header-search').removeClass('active');
    }
    else {
      window.location.href = "/search?q=" + $searchText;
    }
  }
  else {
    $('.header-search').addClass('active');
  }
});

$(document).click(function(e) {
  const $target = $(e.target);
  if($( window ).width() > 999) {
    if(!$target.closest('.header-search').find('.header__link').length) {
      $('.header-search').removeClass('active');
    }
  }
  else {
    if($('.bc-sf-search-suggestion-mobile-top-panel').css('display') == 'block') {
      if(!$('.bc-sf-search-suggestion-mobile-top-panel').find('input').val()) {
        if(!$target.closest('.bc-sf-search-suggestion-mobile-top-panel').length) {
          $('.bc-sf-search-btn-close-suggestion').click();
        }
      }
    }
  }
});

// PRODUCT PAGE 

const $productNav = $('.product-description-nav-item');
const $productContent = $('.product-description-content-item');

$productContent.first().addClass('active');
$productNav.first().addClass('active');

$productNav.click(function() {
  $productNav.removeClass('active');
  $(this).addClass('active');
  $productContent.removeClass('active');
  let $index = $productNav.index($(this));
  $productContent.eq($index).addClass('active');
});

$('.product-description-accordion').find('.product-description-tab').click(function(e) {

  if($(e.target).is('.product-description-tab-heading strong span') || $(e.target).is('.product-description-tab-heading strong')){
    if($(this).hasClass('active')) {
      $('.product-description-tab').removeClass('active');
    }
    else {
      $('.product-description-tab').removeClass('active');
      $(this).addClass('active');
    }
  };
})

// product page review

// check if reviews exists
function checkReviewsExists() {
  if (!$('.spr-reviews').find('.spr-review').length) {
    const $reviewStars = '<span class="spr-starrating spr-summary-starrating"><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i></span>';
    const $noReviewsText = '<p class="product-no-reviews-text">No one has reviewed this product yet</p>';
    $('.block__product-reviews').find('.shopify-reviews').addClass('reviews-not-exist');
    $('.spr-summary').prepend($reviewStars);
    $('.spr-summary-caption').append($noReviewsText);
  }
}

// write new review button
function writeReviewButton() {
  const $writeReviewButton = '<div class="product-new-review-button-wrapper"><div class="product-new-review-button">WRITE A REVIEW</div><div class="product-review-load-button">LOAD MORE</div></div>';
  $('.spr-reviews').append($writeReviewButton);
  if ($('.spr-reviews').find('.spr-review').length > 3){
    $('.product-review-load-button').show();
  }
  $('.product-new-review-button').click(function() {
    $('html,body').animate({scrollTop: $('#shopify-product-reviews').offset().top - 120},'slow');
    $('.spr-summary-actions').find('.spr-summary-actions-newreview').click();
    showReviewForm()
  });
}

// read reviews button
function readReviewsButton() {
  const $readReviewsButton = '<div class="product-read-reviews-button">READ REVIEWS</div>';
  $('.read-reviews-button-wrapper').append($readReviewsButton);
  $('.product-read-reviews-button').click(function() {
    $('html,body').animate({scrollTop: $('#shopify-product-reviews').offset().top - 120},'slow');
    showReviews();
  });
}

function showReviewForm() {
  $('.spr-reviews').css('display', 'none');
  $('.spr-form').css('display', 'block');
  $('.read-reviews-button-wrapper').css('display', 'block');
}

function showReviews() {
  $('.spr-form').css('display', 'none');
  $('.spr-reviews').css('display', 'flex');
  $('.read-reviews-button-wrapper').css('display', 'none');
}

$(document).arrive(".spr-summary-caption", function() {
  checkReviewsExists();
  writeReviewButton();
  readReviewsButton();
});


$('.product-page').arrive(".flickity-button.previous", function() {
  // replace arrow svgs using script instead of background-image which causes issues on IOS Safari

  var prevArrow = 
  '<svg width="6px" height="10px" viewBox="0 0 6 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product" transform="translate(-106.000000, -496.000000)" fill="#070C09"><g id="Group-8" transform="translate(94.000000, 198.000000)"><g id="Group-15" transform="translate(15.000000, 303.000000) scale(-1, 1) translate(-15.000000, -303.000000) translate(0.000000, 288.000000)"><polygon id="Path" transform="translate(15.000000, 15.000000) scale(-1, 1) rotate(90.000000) translate(-15.000000, -15.000000) " points="10 13.0769231 11.0514541 12 14.9888143 15.8901099 18.9261745 12 20 13.0549451 14.9888143 18"></polygon></g></g></g></g></svg>';

  var nextArrow =
  '<svg width="6px" height="10px" viewBox="0 0 9 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Home" transform="translate(-153.000000, -5004.000000)" fill="#000000"><g id="Group-3" transform="translate(50.000000, 4553.000000)"><polygon id="Path" transform="translate(107.500000, 458.500000) scale(-1, 1) rotate(90.000000) translate(-107.500000, -458.500000) " points="100 455.615385 101.577181 454 107.483221 459.835165 113.389262 454 115 455.582418 107.483221 463"></polygon></g></g></g></svg>';

  $('.product-page')
    .find('.flickity-button.previous')
    .html(prevArrow);
    
  $('.product-page')
    .find('.flickity-button.next')
    .html(nextArrow);

});

// CATEGORY LANDING PAGE 

$('.category-help-section').find('.shg-row').flickity({
  prevNextButtons: false,
  watchCSS: true,
  wrapAround: true
});


// SHOGUN CATEGORY PAGES - Fetch and display product tags
$('.category-popular-products .shg-product a').each(function () {
  var $this = $(this);
  var requestLink = $this.attr('href');
  var tagElements = '';
  var tagContainer = '<div class="badge-container"></div>';

  jQuery.getJSON(requestLink + '.js', function(product) {
    $.each(product.tags, function (i, value) {
      if (value.indexOf('label:') >= 0) {
        var tagLabel = value.trim().replace('label:','');
        var tagClass = tagLabel.toLowerCase().replace(' ','-');
        tagElements += '<div class="badges ' + tagClass + '">' + tagLabel + '</div>';
      }
    });

    $this.append($(tagContainer).append(tagElements));
  });
});

// BLOG POST
$('.article-content .featured-products .shg-row').flickity({
  imagesLoaded: true,
  prevNextButtons: true,
  watchCSS: true,
  pageDots: false,
  wrapAround: true,
  autoPlay: true,
  adaptiveHeight: false
});

$(window).on('scroll', function() {
  $('.article-content .featured-products .shg-row').flickity('resize');
  if($(window).scrollTop() <= 70) {
    $('html').removeClass('bottom-page');
  } else {
    $('html').addClass('bottom-page');
  }
});

$('.related-blogs .related-blogs--content').flickity({
  imagesLoaded: true,
  prevNextButtons: false,
  watchCSS: true,
  pageDots: true,
  wrapAround: true
});

// BLOG - If first image is placed on right side of text on desktop, change flex-direction on mobile to maintain image-text order
$('.article-page .section.tips .shg-box-content .shg-row > div:first-child').each(function () {
  $this = $(this);
  if ($this.find('.shogun-image').length == 0 && 
      $this.find('.shogun-video').length == 0) {
    $this
      .closest('.shg-row')
      .addClass('reverse-on-mobile');
  }
});

//CMS - FAQ page
$('.faqs-navigation-container a').click(function(e){
  let href = $(this).attr("href");
  let headerHeight = $('#header').outerHeight();
  if($(window).width() > 767 || $(window).width() < 799) {
    $('html,body').animate({scrollTop: $(href).offset().top - 80 }, 500);
  }
  else {
    $('html,body').animate({scrollTop: $(href).offset().top - headerHeight }, 500);
  }
  e.preventDefault();
});

$('#faq-mobile_nav').change(function() {
  let href = $( "#faq-mobile_nav option:selected" ).val();
  $('html,body').animate({scrollTop: $(href).offset().top - 70}, 500);
})

// Category page
// READ MORE/LESS on collection pages
var showChar = 400;  // character limit
var ellipses = '...';
var readMore = 'Read More';
var readLess = 'Read Less';
var content = $('.footnote .section p').html();

if(content.length > showChar) {
  var visibleContent = content.substr(0, showChar);
  var hiddenContent = content.substr(showChar, content.length - showChar);
  var html = visibleContent + '<span class="more-ellipses">' + ellipses+ '&nbsp;</span><span class="more-content"><span>' + hiddenContent + '</span>&nbsp;&nbsp;<a href="" class="more-link">' + readMore + '</a></span>';
  $('.footnote .section p').html(html);
}

$('.more-link').click(function(){
  if($(this).hasClass('less')) {
    $(this).removeClass('less');
    $(this).html(readMore);
  } else {
    $(this).addClass('less');
    $(this).html(readLess);
  }
  $(this).parent().prev().toggle();
  $(this).prev().toggle();
  return false;
});